<template>
  <transition name="toast-fade">
    <div
      v-if="toast.visible"
      class="toast"
      :class="`toast--${toast.type}`"
      @click="hide"
    >
      {{ toast.message }}
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useUiStore } from '../stores/ui'

const ui = useUiStore()
const toast = computed(() => ui.toast)

const hide = () => {
  ui.hideToast()
}
</script>

<style scoped>
.toast {
  position: fixed;
  right: 16px;
  top:50px;
  padding: 10px 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  color: #ffffff;
  box-shadow: var(--shadow-md);
  cursor: pointer;
  z-index: 9999;
}

.toast--success {
  background-color: #4caf50;
}

.toast--error {
  background-color: #e53935;
}

.toast--info {
  background-color: #1976d2;
}

.toast--warning {
  background-color: #f9a825;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
